import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideTranslateService} from "@ngx-translate/core";
import {UrlUpdateInterceptor} from "./core/interceptors/url-update.interceptor";
import {MessageService} from "primeng/api";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideTranslateService(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([UrlUpdateInterceptor])
    ),
    MessageService,
    importProvidersFrom(BrowserAnimationsModule),
  ]
};
